import React, { useCallback } from 'react';
import styled from 'styled-components';

const Select = styled.select`
  font-size: 1em;
  padding-left: 10px;
  border: 1px solid #000000;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #f1f4f9;
  width: 340px;
  height: 36px;
  color: #3e3c3c;
`;

const Option = styled.option`
  font-style: normal;
  font-weight: normal;
  font-size: 1em;
  // line-height: 17px;
  color: #3e3c3c;
`;

interface SettingsDropDownProps {
  options: { value: any; name: string }[];
  onSelect: (value: any) => void;
  value?: any; // Ensure this line is present
}

const SettingsDropDown = ({ options, onSelect, value }: SettingsDropDownProps) => {
  const handleChange = useCallback((event) => onSelect(event.target.value), []);
  // useEffect(() => {
  //   // options?.length && onSelect(options[0].value);
  // }, [options]);
  return (
    <Select onChange={handleChange} value={value}>
      {options?.map(({ value: optionValue, name }) => (
        <Option key={optionValue} value={optionValue}>
          {name}
        </Option>
      ))}
    </Select>
  );
};
export default SettingsDropDown;
